/**
 * auth 도메인 TanStack Query 키.
 *
 * 두 앱의 QueryClient 는 분리돼 있지만 **같은 세션·같은 `/auth/me`** 를 본다.
 * 키가 갈라지면 "로그인 사용자 캐시를 비운다"는 규칙을 앱마다 따로 기억해야 한다.
 * (verifyEmail/confirmEmailChange 는 현재 web 만 쓰지만, 같은 auth-service 라 여기 둔다)
 */
export const authKeys = {
  all: ['auth'] as const,
  me: ['auth', 'me'] as const,
  /** 첫 로그인 온보딩 진행 상태(구성원·구버전 이관 계정). */
  onboarding: ['auth', 'onboarding'] as const,
  /** 약관 동의 상태(온보딩 동의·재동의 대상 문서). */
  consents: ['auth', 'consents'] as const,
  verifyEmail: (token: string | null) =>
    ['auth', 'verify-email', token] as const,
  confirmEmailChange: (token: string | null) =>
    ['auth', 'confirm-email-change', token] as const,
} as const;
